
angular.module('dybSettings', ['dyb.util', 'classy']);
